import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@clerk/clerk-react';
import axios from 'axios';

const AcceptInviteComplete = () => {
  const navigate = useNavigate();
  const { getToken } = useAuth();
  const [error, setError] = useState('');

  useEffect(() => {
    const sendInviteAccepted = async () => {
      try {
        const token = await getToken();
        if (!token) throw new Error('Token missing');

        await axios.post('/api/accept-invite', {}, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        window.location.replace('/')
      } catch (err) {
        console.error(err);
        setError('Something went wrong finalizing invite.');
      }
    };

    sendInviteAccepted();
  }, [getToken, navigate]);

  return (
    <div className="flex justify-center items-center min-h-screen">
      {error ? <p className="text-red-600">{error}</p> : <p>Finalizing invite...</p>}
    </div>
  );
};

export default AcceptInviteComplete;
